// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormManageEntity } from '../../forms/FormManageEntity/FormManageEntity';

// types
import { EntityType } from '../../../@types';

// props
export interface DialogAddEntityProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	type?: EntityType;
}

export const DialogAddEntity = ({ isOpen, onClose, onSuccess, type }: DialogAddEntityProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	// vars
	const isSupplier = type === 'SUPPLIER';

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: isSupplier ? t('addSupplier') : t('addEntity'),
					loading: isLoading,
					form: 'form-manage-entity',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={550}
			onClose={onClose}
			title={{
				children: isSupplier ? t('addSupplier') : t('addEntity'),
				variant: 'h3',
			}}>
			<FormManageEntity
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
				type={type}
			/>
		</DialogActions>
	);
};
